import { render } from "./WidgetDropdown.vue?vue&type=template&id=6a8d5f32"
import script from "./WidgetDropdown.vue?vue&type=script&lang=js"
export * from "./WidgetDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__